import React, { useEffect, useState } from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import PersonPinCircle from "@material-ui/icons/PersonPinCircle";
import PeopleIcon from "@material-ui/icons/People";
import WarningIcon from "@material-ui/icons/Warning";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import WatchLaterIcon from "@material-ui/icons/WatchLater";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import ErrorIcon from "@material-ui/icons/Error";
import HomeIcon from "@material-ui/icons/Home";
import { makeStyles } from "@material-ui/core/styles";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { Link } from "react-router-dom";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import BookIcon from "@material-ui/icons/Book";
import Badge from "@material-ui/core/Badge";
import {
  countSolicitudes,
  countReclamos,
  countAssistance,
  countIncidents,
  updateSolicitudesViewed,
  updateIncidentsViewed,
  updateAssistance,
  updateReclamosViewed,
} from "../utils/Actions";

const useStyles = makeStyles((theme) => ({
  nolink: {
    textDecoration: "none",
    color: "#000",
  },
}));

export function MainListItems() {
  const classes = useStyles();
  const account = localStorage.getItem("Account");
  const accountJSON = JSON.parse(account);
  const { rol, accountAsigned } = accountJSON[0];
  const [solicitudes, setsolicitudes] = useState(0);
  const [reclamos, setreclamos] = useState(0);
  const [asistencias, setasistencias] = useState(0);
  const [incidentes, setincidentes] = useState(0);
  const [change, setchange] = useState(false); //Ver aquí.

  useEffect(() => {
    (async () => {
      //  setInterval(async () => {
      setsolicitudes(await countSolicitudes(setchange, setsolicitudes));
      setreclamos(await countReclamos(setchange, setreclamos));
      setasistencias(await countAssistance(setchange, setasistencias));
      setincidentes(await countIncidents(setchange, setincidentes));
      //   }, 5000);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      //  setInterval(async () => {
      setsolicitudes(await countSolicitudes(setchange, setsolicitudes));
      setreclamos(await countReclamos(setchange, setreclamos));
      setasistencias(await countAssistance(setchange, setasistencias));
      setincidentes(await countIncidents(setchange, setincidentes));
      //   }, 5000);
    })();
  }, [change]);

  const updateSolicitudes = async () => {
    if (solicitudes > 0) {
      await updateSolicitudesViewed();
      setchange(!change);
    }
  };

  const updateReclamos = async () => {
    if (reclamos > 0) {
      await updateReclamosViewed();
      setchange(!change);
    }
  };

  const updateAsistencias = async () => {
    if (asistencias > 0) {
      await updateAssistance();
      setchange(!change);
    }
  };

  const updateIncidentes = async () => {
    if (incidentes > 0) {
      await updateIncidentsViewed();
      setchange(!change);
    }
  };

  //si es cliente = 4 tiene un menu y si no tiene otro
  return rol !== 4 ? (
    <div>
      <Link to="/" className={classes.nolink}>
        <ListItem button>
          <ListItemIcon>
            <Badge badgeContent={0} color="secondary">
              <HomeIcon />
            </Badge>
          </ListItemIcon>
          <ListItemText primary="Dashboard" />
        </ListItem>
      </Link>
      <Link to="/users" className={classes.nolink}>
        <ListItem button>
          <ListItemIcon>
            <Badge badgeContent={0} color="secondary">
              <PeopleIcon />
            </Badge>
          </ListItemIcon>
          <ListItemText primary="Usuarios" />
        </ListItem>
      </Link>
      <Link to="/insite" className={classes.nolink}>
        <ListItem button>
          <ListItemIcon>
            <Badge badgeContent={0} color="secondary">
              <VerifiedUserIcon />
            </Badge>
          </ListItemIcon>
          <ListItemText primary="En Turno" />
        </ListItem>
      </Link>
      <Link to="/requests" className={classes.nolink}>
        <ListItem button onClick={updateSolicitudes}>
          <ListItemIcon>
            <Badge badgeContent={solicitudes} color="secondary">
              <AssignmentIndIcon />
            </Badge>
          </ListItemIcon>
          <ListItemText primary="Solicitudes" />
        </ListItem>
      </Link>
      <Link to="/visits" className={classes.nolink}>
        <ListItem button>
          <ListItemIcon>
            <Badge badgeContent={0} color="secondary">
              <PersonPinCircle />
            </Badge>
          </ListItemIcon>
          <ListItemText primary="Visitas" />
        </ListItem>
      </Link>
      <Link to="/loghistory" className={classes.nolink}>
        <ListItem button>
          <ListItemIcon>
            <Badge badgeContent={0} color="secondary">
              <BookIcon />
            </Badge>
          </ListItemIcon>
          <ListItemText primary="Bitácora" />
        </ListItem>
      </Link>
      <Link to="/incidents" className={classes.nolink}>
        <ListItem button onClick={updateIncidentes}>
          <ListItemIcon>
            <Badge badgeContent={incidentes} color="secondary">
              <WarningIcon />
            </Badge>
          </ListItemIcon>
          <ListItemText primary="Incidentes" />
        </ListItem>
      </Link>
      <Link to="/customers" className={classes.nolink}>
        <ListItem button>
          <ListItemIcon>
            <Badge badgeContent={0} color="secondary">
              <AccountBoxIcon />
            </Badge>
          </ListItemIcon>
          <ListItemText primary="Clientes" />
        </ListItem>
      </Link>
      <Link to="/assistance" className={classes.nolink}>
        <ListItem button onClick={updateAsistencias}>
          <ListItemIcon>
            <Badge badgeContent={asistencias} color="secondary">
              <WatchLaterIcon />
            </Badge>
          </ListItemIcon>
          <ListItemText primary="Asistencias" />
        </ListItem>
      </Link>
      <Link to="/claims" className={classes.nolink}>
        <ListItem button onClick={updateReclamos}>
          <ListItemIcon>
            <Badge badgeContent={reclamos} color="secondary">
              <ErrorIcon />
            </Badge>
          </ListItemIcon>
          <ListItemText primary="Reclamos" />
        </ListItem>
      </Link>

      <ListItem
        button
        onClick={() => {
          localStorage.clear();
        }}
      >
        <ListItemIcon>
          <ExitToAppIcon />
        </ListItemIcon>
        <ListItemText primary="Cerrar Sesión" />
      </ListItem>
    </div>
  ) : (
    <div>
      <Link to="/" className={classes.nolink}>
        <ListItem button>
          <ListItemIcon>
            <Badge badgeContent={0} color="primary">
              <HomeIcon />
            </Badge>
          </ListItemIcon>
          <ListItemText primary="Dashboard" />
        </ListItem>
      </Link>
      <Link to="/visits" className={classes.nolink}>
        <ListItem button>
          <ListItemIcon>
            <PersonPinCircle />
          </ListItemIcon>
          <ListItemText primary="Visitas" />
        </ListItem>
      </Link>
      <Link to="/insite" className={classes.nolink}>
        <ListItem button>
          <ListItemIcon>
            <Badge badgeContent={0} color="secondary">
              <VerifiedUserIcon />
            </Badge>
          </ListItemIcon>
          <ListItemText primary="En Turno" />
        </ListItem>
      </Link>
      <Link to="/incidents" className={classes.nolink}>
        <ListItem button>
          <ListItemIcon>
            <WarningIcon />
          </ListItemIcon>
          <ListItemText primary="Incidentes" />
        </ListItem>
      </Link>

      <Link to="/claims" className={classes.nolink}>
        <ListItem button>
          <ListItemIcon>
            <ErrorIcon />
          </ListItemIcon>
          <ListItemText primary="Reclamos" />
        </ListItem>
      </Link>

      <ListItem
        button
        onClick={() => {
          localStorage.clear();
        }}
      >
        <ListItemIcon>
          <ExitToAppIcon />
        </ListItemIcon>
        <ListItemText primary="Cerrar Sesión" />
      </ListItem>
    </div>
  );
}
